import React from "react";
import { Link } from "react-router-dom";
import HomeData from "../../../data/home.json";
function ServiceTwoArea() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <>
      <div className="service-section pt-120 pb-120">
        <div className="container">
          <div className="row mb-4 pb-3 d-flex justify-content-lg-start justify-content-center align-items-center">
            <div className="col-lg-8  text-lg-start text-center">
              <div
                className="section-title2 wow animate fadeInDown"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
                <h2 className="cusm-front" >Our Services</h2>
                {/* <h2 className="cusm-front ">We Shape The Perfect Solutions</h2> */}
              </div>
            </div>
 
          </div>
          <div className="row d-flex justify-content-center g-4">
            {HomeData[2].serivce?.slice(0, 6).map((solution) => (
              <div
                className="col-xl-6 col-lg-4 col-md-6 col-sm-8"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
                <div className="service-item light-mode hover-btn d-flex justify-content-between align-items-center">
                  <div className="s-content pt-4 ">

                    <h4 className="cusm-front">
                      <Link
                        to={`${process.env.PUBLIC_URL}/service-details`}
                        onClick={scrollTop}
                      >
                           <img className="custom_image_solutionandserver " src={solution.image} alt="" />
                        {solution?.heading}
                      </Link>
                    </h4>
                    <p className="solution_para_home pt-4"     dangerouslySetInnerHTML={{ __html: solution.description }}>

                    </p>

                  </div>
                  <span />

                </div>
              </div>
            ))}



          </div>

        </div>
        <div className="row mt-3">
          <div className="col-lg-6"></div>
          <div
            className="col-lg-4 text-lg-end text-center wow animate fadeInDown"
            data-wow-duration="1.5s"
            data-wow-delay="0.6s"
          >
            <Link
              to={`${process.env.PUBLIC_URL}/service`}
              onClick={scrollTop}
              className="eg-btn outlined-btn hover-btn hover-btn-cusm"
            >
              <span>
                Explore More
                <img
                  src={
                    process.env.PUBLIC_URL + "/images/icon/arrow-black.svg"
                  }
                  alt="images"
                />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default ServiceTwoArea;
